import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gray-100 py-4 mt-10 text-center text-sm text-gray-600">
      © {new Date().getFullYear()} AcheiPreço — Todos os direitos reservados.
    </footer>
  );
}
